const DEV_ADMIN_USERS = [242];
const PROD_ADMIN_USERS = [1, 2];
// TODO: query a server endpoint
export default async function isAdmin(userId) {
  if (userId === undefined || userId === null) {
    console.error("userId must be set");
  }
  const adminUserIds = process.env.NODE_ENV === "development" ? DEV_ADMIN_USERS : PROD_ADMIN_USERS;
  return adminUserIds.includes(userId);
}
